import { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  Bullet,
  Pipe,
  TextRow,
  StyledBodyCopy,
  StyledBodyCopyWithSpacing,
  SubHeaderWrapper,
} from './component.styles'

const InterventionsSubheader = ({ className, countData, numberOfSites }) => {
  const numberOfSchoolsText = `**${numberOfSites}** Schools **•**`
  const smallGroupsCreatedText = `**${countData.smallGroupsCreated}** Small Groups Created`
  const groupsThatHaventCompletedLessonText = `**${
    countData.groupsThatHaventCompletedLesson
  }** group${
    countData.groupsThatHaventCompletedLesson === 1 ? " hasn't" : "s haven't"
  } completed a lesson`
  const lessonsCompletedText = `**${countData.lessonsCompleted}** Lessons Completed`

  return (
    <SubHeaderWrapper className={className}>
      <TextRow>
        {numberOfSites > 1 && (
          <StyledBodyCopyWithSpacing>
            {numberOfSchoolsText}
          </StyledBodyCopyWithSpacing>
        )}
        <StyledBodyCopy>{smallGroupsCreatedText}</StyledBodyCopy>
        {countData.groupsThatHaventCompletedLesson > 0 && (
          <Fragment key="groups-not-completed">
            <Pipe>{'|'}</Pipe>
            <Bullet />
            <StyledBodyCopy>
              {groupsThatHaventCompletedLessonText}
            </StyledBodyCopy>
          </Fragment>
        )}
      </TextRow>
      {numberOfSites > 1 && (
        <Fragment key="lessons-completed">
          <StyledBodyCopy>{lessonsCompletedText}</StyledBodyCopy>
        </Fragment>
      )}
    </SubHeaderWrapper>
  )
}

InterventionsSubheader.propTypes = {
  className: PropTypes.string,
  countData: PropTypes.shape({
    groupsThatHaventCompletedLesson: PropTypes.number.isRequired,
    lessonsCompleted: PropTypes.number.isRequired,
    smallGroupsCreated: PropTypes.number.isRequired,
  }).isRequired,
  numberOfSites: PropTypes.number.isRequired,
}

export default InterventionsSubheader
